import React from 'react';
import MuiPaginationItem from '@mui/material/PaginationItem';
import type {PaginationItemProps as MuiPaginationItemProps} from '@mui/material/PaginationItem';

export type PaginationItemProps = MuiPaginationItemProps;

export const PaginationItem = React.forwardRef<any, PaginationItemProps>(
    ({
        children,
        ...props
    }, ref) => (
        <MuiPaginationItem
            {...props}
            ref={ref}
        >
            {children}
        </MuiPaginationItem>
    ));

PaginationItem.displayName = 'PaginationItem';
